import { createIcon } from '@chakra-ui/react'

export const Updown = createIcon({
  displayName: 'Updown',
  viewBox: '0 0 10 12',
  d: 'M7.66671 9.34V4.66667H6.33337V9.34H4.33337L7.00004 12L9.66671 9.34H7.66671ZM3.00004 0L0.333374 2.66H2.33337V7.33333H3.66671V2.66H5.66671L3.00004 0ZM7.66671 9.34V4.66667H6.33337V9.34H4.33337L7.00004 12L9.66671 9.34H7.66671ZM3.00004 0L0.333374 2.66H2.33337V7.33333H3.66671V2.66H5.66671L3.00004 0Z',
})
